import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Colors = /*#__PURE__*/function () {
  function Colors() {
    _classCallCheck(this, Colors);
  }

  _createClass(Colors, null, [{
    key: "colorString",
    value: function colorString(_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          r = _ref2[0],
          g = _ref2[1],
          b = _ref2[2];

      return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
    }
  }, {
    key: "colorStringRaw",
    value: function colorStringRaw(_ref3) {
      var _ref4 = _slicedToArray(_ref3, 3),
          r = _ref4[0],
          g = _ref4[1],
          b = _ref4[2];

      return "".concat(r, ", ").concat(g, ", ").concat(b);
    }
  }, {
    key: "darkenBy",
    value: function darkenBy(baseColor, opacity) {
      var mask = [0, 0, 0];
      return Colors.mixColor(baseColor, mask, opacity);
    }
  }, {
    key: "mixColor",
    value: function mixColor(_ref5, _ref6, opacity) {
      var _ref7 = _slicedToArray(_ref5, 3),
          r = _ref7[0],
          g = _ref7[1],
          b = _ref7[2];

      var _ref8 = _slicedToArray(_ref6, 3),
          maskR = _ref8[0],
          maskG = _ref8[1],
          maskB = _ref8[2];

      var inverseOpacity = 1 - opacity;
      return [parseInt(r * opacity + maskR * inverseOpacity, 10), parseInt(g * opacity + maskG * inverseOpacity, 10), parseInt(b * opacity + maskB * inverseOpacity, 10)];
    }
  }, {
    key: "brightness",
    value: function brightness(_ref9) {
      var _ref10 = _slicedToArray(_ref9, 3),
          r = _ref10[0],
          g = _ref10[1],
          b = _ref10[2];

      return r * 0.299 + g * 0.587 + b * 0.114;
    }
  }, {
    key: "hexToRgb",
    value: function hexToRgb(hexColor) {
      if (!hexColor || hexColor.length !== 6) {
        throw new Error('Invalid color');
      }

      return [parseInt(hexColor.substr(0, 2), 16), parseInt(hexColor.substr(2, 2), 16), parseInt(hexColor.substr(4, 2), 16)];
    }
  }]);

  return Colors;
}();

Colors.BRIGHTNESS_THRESHOLD = 180;
export { Colors as default };